export default __webpack_public_path__ + "static/get_app@2x-be95da84002b15488352fd181a46cc7c.jpg";